<div class="checkout">
    @if(package(); as pkg){
    <cart-summary [class.cosmetic]="isLoading()" [package]="pkg" [use]="selected_use()" />
    @let cart = cartSummary()!;
    <div class="discount-form">
        <div class="header f-main-between f-cross-center">
            <h3>Got a <span bold>discount code</span>?</h3>
            @if(package_uses().length){
            <button class="codes premium-horizontal" mat-flat-button (click)="openCouponSelector()">
                MY CODES
            </button>
            }
        </div>
        <div class="floating-control has-icon" [class.cosmetic]="isLoading()">
            <div class="icon" [class.cosmetic]="coupon_state() != 'failed'" (click)="code.reset('')" mat-ripple>
                @switch(coupon_state()){
                    @case ('success'){
                        <mat-icon paint="success">done</mat-icon>
                    }
                    @case ('pending'){
                        <mat-icon paint="accent">hourglass_empty</mat-icon>
                    }

                    @case ('failed'){
                        <mat-icon paint="warn">clear</mat-icon>
                    }

                    @default {
                        <mat-icon paint="dark">keyboard</mat-icon>
                    }
                }
            </div>

            <input matInput type="text" [formControl]="code" placeholder="Enter your code here" id="coupon" />
        </div>
        <div class="field-info">
            @if(code.touched){
                @if(code.hasError('coupon')){
                    <mat-error>
                        {{code.getError('coupon')}}
                    </mat-error>
                    } @else if (coupon_state() == 'success'){
                    <mat-hint>
                        Code has been applied.<br />
                        <span>
                            Discounted price can be seen above.
                        </span>
                    </mat-hint>
                    } @else if(coupon_state() == 'idle' && !cart.retailable() && !selected_use_id()){
                        <mat-error>
                            A code is required for this plan.
                        </mat-error>
                    } @else {
                        <mat-hint>&nbsp;</mat-hint>
                    }
                    } @else {
                <mat-hint>&nbsp;</mat-hint>
            }
        </div>
        @if(!email_verified()){
            <br />
            <mat-divider></mat-divider>
            <h3>Email Address</h3>
            <div class="floating-control has-icon" [class.cosmetic]="isLoading()">
                <div class="icon">
                    <mat-icon color="dark" matTooltip="A receipt will be sent to the given email address">info</mat-icon>
                </div>

                <input matInput type="text" [formControl]="email" normal placeholder="Enter your email address here"
                    id="email" />
            </div>
            <div class="field-info">
                @if(email.touched && email.errors; as email_errors){
                <mat-error>
                    @if(email_errors.required){
                        Please enter an email address
                    } @else if(email_errors.email){
                        Please enter a valid email address
                    } @else {
                        Please enter an email address
                    }
                </mat-error>
                } @else {
                <mat-hint>&nbsp;</mat-hint>
                }
            </div>
        }
        <br/>
        <div [class.no-display]="cart.no_card_required() || !cart.retailable()">
            <mat-divider></mat-divider>
            <h3>Payment Method</h3>
            <div class="card-selection px-8">
                @if(uses()){
                    <card-input ngSkipHydration [manual]="true" [package]="pkg._id" [use]="selected_use_id()" target="package" (paymentComplete)="onPayment($event)"/>
                }
            </div>
            <br />
        </div>
        @if(cart.retailable()){
            <mat-divider></mat-divider>
            <br/>
            <div class="terms" [class.cosmetic]="isLoading()">
                <mat-slide-toggle paint="warn" [formControl]="terms">I hereby accept the Terms and Conditions, Cancellation and Privacy Policy. I expressly consent to the receipt of digital content in the form of cloudigo discounts to be redeemed at various outlets and I acknowledge that in so doing, I waive the cooling-off period. Nevertheless, I can still cancel my subscription at any time.</mat-slide-toggle>
                <mat-error class="mt-4" [class.transparent]="terms.valid || terms.untouched">Please accept the terms and conditions to proceed.</mat-error>
            </div>
        }
        <div class="go-next">
            <button mat-flat-button class="premium-horizontal" [disabled]="block_transaction()" (click)="goNext(package()?._id, selected_use_id())">
                @if(!isLoading()){
                    <span class="font-extrabold">
                        {{cart.no_card_required() ? 'USE NOW' : 'PAY NOW'}}
                    </span>
                } @else {
                    <mat-icon class="rotating sized" style="margin: 0; --icon-size: 24px;">autorenew</mat-icon>
                }
            </button>
            @if(cart.retailable()){
                €{{pkg.price}}/{{pkg.unit}} after. Cancel Anytime.
                <br/>
                <small><a routerLink="/terms-and-conditions">Terms & Conditions Apply</a>.</small>
            }
        </div>
    </div>
    }
</div>